interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img 
              src="https://public.readdy.ai/ai/img_res/64b3e9a0-49cf-4dd6-a92f-093831b5cfed.png" 
              alt="Gary Wilson Logo" 
              className="h-12 w-12 object-contain"
            />
            <span className={`text-xl font-bold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>Gary Wilson</span>
          </div>
          
          <div className="flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors hover:text-amber-600 whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('biography')}
              className={`text-sm font-medium transition-colors hover:text-amber-600 whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Biography
            </button>
            <button 
              onClick={() => scrollToSection('books')}
              className={`text-sm font-medium transition-colors hover:text-amber-600 whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Books
            </button>
            <button 
              onClick={() => scrollToSection('events')}
              className={`text-sm font-medium transition-colors hover:text-amber-600 whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Events
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`px-6 py-2 bg-amber-600 text-white rounded-full text-sm font-medium hover:bg-amber-700 transition-colors whitespace-nowrap ${scrolled ? '' : 'shadow-lg'}`}
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}